import * as React from 'react';
import assertNever from 'assert-never';

enum ActionTypes {
  TOGGLE = 'TOGGLE',
  ON = 'ON',
  OFF = 'OFF',
}

const initialState = {
  on: false,
};
type AllActions = { type: ActionTypes };
type State = typeof initialState;

function toggleReducer(state: State = initialState, action: AllActions) {
  switch (action.type) {
    case ActionTypes.TOGGLE: {
      return { on: !state.on };
    }
    case ActionTypes.ON: {
      return { on: true };
    }
    case ActionTypes.OFF: {
      return { on: false };
    }
    default: {
      assertNever(action.type);
    }
  }
}

export function useToggle(isOn = false) {
  const [{ on }, dispatch] = React.useReducer(toggleReducer, { on: isOn });

  const toggle = () => dispatch({ type: ActionTypes.TOGGLE });
  const setOn = () => dispatch({ type: ActionTypes.ON });
  const setOff = () => dispatch({ type: ActionTypes.OFF });

  return { on, toggle, setOn, setOff };
}
